import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";

// namespace SlotGames
// {

	export class RainbowMagic_2Screen extends SlotGameType1_2Screen {

        //protected panelFactory:IPanelFactory = new RainbowMagicPanelFactory();
		protected override helpFactory:IHelpFactory = new RainbowMagicHelpFactory();
        

        
        //LED COLOR
		protected override ColorLed:string="255,255,0\n";
		
		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
			super(multigameParams, initData, "RainbowMagic");
			this.spinnableReelsParams.topBorderWidth = 0;
			this.spinnableReelsParams.bottomBorderWidth = 0;
		
        }
        
        //SEND COLOR FOR SRA
    protected override color: RewardColor =
    {
        color: "#F9F8E2",
        coloroutherStroke: "#013809",
        colorinnerStroke: "#0EE104"
    }

		
    }
    

	


//Panel Colorized merged
class RainbowMagicPanelFactory implements IPanelFactory
{
    public CreateNewPanel(params: PanelParams):Panel
    {
        return new RainbowMagicPanel(params);
    }
}

class RainbowMagicPanel extends Panel
{
    protected override ButtonBackground():ButtonColors
    {
        let color:ButtonColors ={
            backgroundButtonColor: "linear-gradient(rgb(2, 38, 1),rgb(3, 64, 1), rgb(85, 140, 3),rgb(3, 64, 1),rgb(2, 38, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            linearColor:"linear-gradient(to left , transparent, chartreuse,transparent ) 0 10 100%",
        };
        
        return color;
    }

}

class RainbowMagicHelpFactory implements IHelpFactory
{
    public CreateNewHelp(params: HelpParameters):Help
    {
        return new   RainbowMagicHelp(params);
    }
}

class RainbowMagicHelp extends Help
{
    protected override BackgroundPanel():HelpPanelColor
    {
        let color:HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(2, 38, 1),rgb(3, 64, 1), rgb(85, 140, 3),rgb(3, 64, 1),rgb(2, 38, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}
